<template>
  <div class="exportloading flex-ac flex-c">
    <div class="exportCont">
      <img src="@/assets/images/export.png" alt="" class="image" />
      <img
        src="@/assets/images/close.png"
        alt=""
        class="close"
        @click="closeExport"
      />
      <p class="flex-ac flex-sb">
        <span
          style="font-size: 18px;
                  font-weight: 400;
                  letter-spacing: 0px;
                  line-height: 26px;
                  color: rgba(69, 73, 77, 1);"
          >正在导出数据...</span
        >
        <span
          v-if="num"
          style="font-size: 18px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 26px;
                color: rgba(153, 153, 153, 1);"
          >{{ num }}%</span
        >
      </p>
      <div class="progress">
        <img
          src="@/assets/images/progressImg.png"
          alt=""
          class="progressImg"
          :style="{ right: 100 - num + '%' }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["num"],
  components: {},
  computed: {
    ...mapGetters([""])
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {
    format(percentage) {
      return percentage === 100 ? "完成" : `${percentage}%`;
    },
    closeExport() {
      this.$emit("closeExport");
    }
  },
  destroyed() {}
};
</script>
<style lang="stylus" scoped>
.exportloading {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  top: 0;
  left: 0;
  z-index: 3;

  .el-progress {
    width: 400px;
  }
  .exportCont{
    position relative
    width: 384px;
    height: 158px;
    opacity: 1;
    border-radius: 10px;
    background: rgba(255, 255, 255, 1);
    .image{
      position absolute
      top 0
      left 50%
      transform: translate(-50%,-50%)
      width: 152px;
    }
    .close{
      width: 26px;
      height: 26px;
      position absolute
      top 10px
      right 10px
      cursor pointer
    }
    p{
      top 50%
      left 50%
      transform: translate(-50%,-50%)
      position absolute
      width 80%
    }

    .progress{
      top 70%
      left 50%
      transform: translate(-50%,-50%)
      position absolute
      width 80%
      height: 8px;
      overflow hidden
      border-radius: 4px
      background: rgba(240, 240, 240, 1);
      .progressImg{
        position absolute
        width 100%
        height 100%
        top 0
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/exportloading.vue